<script setup>
import Workfile from '@/components/workfile/Workfile.vue';
</script>

<template>
    <workfile />
</template>